var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginCheckActivated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_circle_white_48dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14975",
    "data-name": "Path 14975",
    d: "M0,0H35V35H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14976",
    "data-name": "Path 14976",
    d: "M17.5,4A13.5,13.5,0,1,0,31,17.5,13.518,13.518,0,0,0,17.5,4ZM14.125,25.938l-6.75-6.75,2.379-2.379,4.371,4.354L25.246,10.041l2.379,2.4Z",
    transform: "translate(0 0)",
    fill: "#b2c025",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14977",
    "data-name": "Path 14977",
    d: "M18.885,2A16.885,16.885,0,1,0,35.77,18.885,16.891,16.891,0,0,0,18.885,2Zm0,30.393A13.508,13.508,0,1,1,32.393,18.885,13.526,13.526,0,0,1,18.885,32.393Zm7.75-20.971L15.508,22.549l-4.373-4.356L8.754,20.573l6.754,6.754L29.016,13.819Z",
    transform: "translate(-1.385 -1.385)",
    fill: "#b2c025"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCheckActivated);
export default __webpack_public_path__ + "static/media/login-check-activated.3229807ae467620fc9f46902ecbf932f.svg";
export { ForwardRef as ReactComponent };